import * as React from 'react';
import { RadioGroup } from 'wix-style-react';
import { CycleDetails } from 'types';
import s from './Cycles.scss';

interface CycleCheckboxProps {
  isCycleSelected: boolean;
  cycleDetails: CycleDetails;
}

export const CycleCheckbox: React.FC<CycleCheckboxProps> = (props) => {
  const { isCycleSelected, cycleDetails } = props;
  return (
    <div className={s.advancedPlans}>
      <RadioGroup.Radio
        dataHook={`cycle-entry-checkbox-${cycleDetails.cycleId}`}
        checked={isCycleSelected}
        disabled={cycleDetails.isCycleDisabledInProduct}
      />
    </div>
  );
};
